<template>
  <form-wizard
    ref="refFormWizard"
    color="#7367F0"
    :title="null"
    :subtitle="null"
    finish-button-text="Submit"
    back-button-text="Previous"
    hide-buttons
    class="checkout-form-wizard steps-transparent"
  >
    <!-- account detail tab -->
    <tab-content
      title="Cart"
    >
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <e-commerce-checkout-step-cart
          :product-in-cart="productInCart"
          :total-price="totalPrice"
          :subtotal-price="subtotalPrice"
          @refresh-cart="get_product_cart(false)"
          @next-step="navigateToAddress"
        />
      </b-overlay>
    </tab-content>

    <!-- address -->
    <tab-content
      title="Address"
    >
      <e-commerce-checkout-step-address
        :address-details="checkoutDetails.address"
        @deliver-to-this-address="navigateToPayment"
      />
    </tab-content>

    <!-- social link -->
    <tab-content
      title="Payment"
    >
      <e-commerce-checkout-step-payment
        :payment-details="checkoutDetails.payment"

        :product-in-cart="productInCart"
        @submit="saveCheckout"
      />
    </tab-content>
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ref } from '@vue/composition-api'
import ECommerceCheckoutStepCart from './MarketplaceCheckoutStepCart.vue'
import ECommerceCheckoutStepAddress from './MarketplaceCheckoutStepAddress.vue'
import ECommerceCheckoutStepPayment from './MarketplaceCheckoutStepPayment.vue'

export default {
  components: {
    // 3rd Party
    FormWizard,
    TabContent,

    // SFC
    ECommerceCheckoutStepCart,
    ECommerceCheckoutStepAddress,
    ECommerceCheckoutStepPayment,
  },
  setup() {
    const refFormWizard = ref(null)
    const formWizardNextStep = () => {
      refFormWizard.value.nextTab()
    }

    // ? This is just dummy details
    const checkoutDetails = ref({
      address: {
        fullName: '',
        mobile: '',
        houseNo: '',
        landmark: '',
        city: '',
        pincode: '',
        state: '',
        addressType: null,
      },
      payment: {
        cvv: '',
      },
    })

    return {
      refFormWizard,
      formWizardNextStep,

      // Dummy Details
      checkoutDetails,
    }
  },

  data() {
    return {
      isLoading: true,
      checkout: {},

      productInCart: [],
      subtotalPrice: 0,
      totalPrice: 0,

      deliveryAddress: {},
    }
  },
  created() {
    this.get_product_cart()
  },
  methods: {
    get_product_cart(isLoading = true) {
      this.isLoading = isLoading
      
      this.$http
        .get(`/api/product-cart`)
        .then(response => {
          const { success, output } = response.data

          if (success) {
            this.productInCart = output
            this.subtotalPrice = 0
            this.productInCart.forEach(inCart => {
              this.subtotalPrice += (inCart.quantity * inCart.product.price)
            })

            // TODO: subtract with other fees and taxes
            this.totalPrice = this.subtotalPrice
          } else {
            this.productInCart = []
            this.subtotalPrice = 0

            // TODO: subtract with other fees and taxes
            this.totalPrice = this.subtotalPrice
          }

          this.isLoading = false
        })
        .catch(() => {})
    },

    navigateToAddress() {
      this.get_product_cart()
      this.formWizardNextStep()
    },

    navigateToPayment(event) {
      this.deliveryAddress = event
      this.formWizardNextStep()
    },

    saveCheckout(event) {

      

      this.productInCart.forEach(inCart => {
      
        let cart = [ inCart]
        this.payment = event

      const form_data = {
        payment: this.payment,
        delivery_id: this.deliveryAddress._id,
        cart: cart,
        subtotal_price: this.subtotalPrice,
        status : 'Waiting Confirmation',
        total_price: this.totalPrice,
      }
      this.$http
        .post(`/api/marketplace/checkouts`, {
          form_data,
        })
        .then(response => {
          const { success, output, message } = response.data

          if (success) {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Product Notification',
                  icon: 'CheckCircleIcon',
                  text: message,
                  variant: 'success',
                },
              },

              { timeout: this.$longestTimeout },
            )
            this.saveOrder(cart, output._id)
            this.$router.push({name: 'marketplace'})
          } else {
            this.$toast(
              {
                component: this.$toastContent,
                props: {
                  title: 'Product Notification',
                  icon: 'AlertCircleIcon',
                  text: message,
                  variant: 'error',
                },
              },
              { timeout: this.$longestTimeout },
            )
          }
        })
        .catch(() => {})
        })
    },
    saveOrder(cart, id){      

        const orders = {
          transaction_id : id,
          delivery_id : this.deliveryAddress._id,
          product_id : cart.product_id,
          seller : cart.product.created_by,
          buyer : cart.created_by,
          quantity : cart.quantity,
          price : cart.product.price,
          total_price : (cart.product.price * cart.quantity),
          status : 'Waiting Confirmation'
        }

        this.$http
        .post(`/api/marketplace/orders`, {
          orders,
        })
        .then(response => {
          const { success, output, message } = response.data
        })
        .catch(() => {})


    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
</style>

<style lang="scss" scoped>
.checkout-form-wizard ::v-deep {
  .wizard-tab-content {
    box-shadow: none !important;
    background: transparent !important;
    padding: 0;
  }
}
</style>
